<cdx-slotted-modal (close)="close()" [size]="size" [mobileFullHeight]="true">
	<h2 modal-header i18n="@@directToBootInformation-mainHeading">
		<span>How does it work?</span>
	</h2>
	<div modal-content>
		<section class="instructions">
			<div class="instructions-info">
				<img
					alt="We’ll load your order into your boot"
					class="howItWorks"
					src="/assets/images/how-it-works/direct-to-boot.png"
				/>
				<div class="text-container">
					<h5 i18n="@@directToBootInformation-followInstructionsInSmsHeading">
						We’ll load your order into your boot
					</h5>
					<p i18n="@@directToBootInformation-followInstructionsInSmsHeadingContent">
						Park in the Direct to Boot bay, stay in your car, and we’ll place your order into your boot.
					</p>
				</div>
			</div>

			<div class="instructions-info">
				<img
					alt="I’ll load my own order"
					class="howItWorks"
					src="/assets/images/how-it-works/i-will-load-my-order.png"
				/>
				<div class="text-container">
					<h5 i18n="@@directToBootInformation-followInstructionsInSmsHeading">
						I’ll load my own order
					</h5>
					<p i18n="@@directToBootInformation-followInstructionsInSmsHeadingContent">
						Park in a designated bay, then head to the door with the Direct to Boot logo to collect your
						order.
					</p>
				</div>
			</div>

			<div class="safety-info">
				<h2>What happens next?</h2>
				<div class="instructions-info">
					<cdx-svg-icon name="mob-chat"></cdx-svg-icon>
					<div>
						<h5 i18n="@@pickupPointInformation-followInstructionsInSmsHeading">Get a text notification</h5>
						<p i18n="@@pickupPointInformation-followInstructionsInSmsHeadingContent">
							We’ll let you know when your order is ready. Tap the link to confirm you’re on your way.
						</p>
					</div>
				</div>
				<div class="instructions-info">
					<cdx-svg-icon name="car" fill="dark"></cdx-svg-icon>
					<div>
						<h5 i18n="@@pickupPointInformation-parkingHeading">Park in a Direct to Boot bay</h5>
						<p i18n="@@pickupPointInformation-parkingContent">Park in a bay near the store entrance. For safety, some stores may require reverse parking.</p>
					</div>
				</div>
				<div class="instructions-info">
					<cdx-svg-icon name="chat" fill="dark"></cdx-svg-icon>
					<div>
						<h5 i18n="@@pickupPointInformation-letUsKnowHeading">Let us know you’ve arrived</h5>
						<p i18n="@@pickupPointInformation-letUsKnowContent">Tap the same link again in your text to notify us, and we’ll get your order ready for loading or collection.</p>
					</div>
				</div>
			</div>
		</section>

		<section class="instructions">
			<div class="safety-info">
				<p i18n="@@directToBootInformation-followInstructionsInSmsHeadingContent" class="faq-link">
					Got questions? Visit our <a href="/shop/content/direct-to-boot">FAQs page</a> to learn more about
					Direct to Boot.
				</p>
			</div>
		</section>
	</div>
</cdx-slotted-modal>
